import { Routes, RouterModule } from "@angular/router";

import { HomeComponent } from "./home";
import { LoginComponent } from "./login";
import { VisorComponent } from "./componentes/visor/visor.component";
import { AuthGuard } from "./_helpers";
import { AdminLayoutComponent } from "./layouts/admin/admin-layout.component";
import { AuthLayoutComponent } from "./layouts/auth/auth-layout.component";
import { NgModule } from "@angular/core";
const AppRoutes: Routes = [
  
  { path: "login", component: LoginComponent },
  {
    path: "",
    component: AdminLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: "", redirectTo: "dashboard/dashboard", pathMatch: "full" },
      {
        path: "dashboard",
        loadChildren: "./dashboard/dashboard.module#DashboardModule",
      },
      {
        path: "medicionyfacturacion",
        loadChildren:
          "./medicionyfacturacion/medicionyfacturacion.module#MedicionyfacturacionModule",
      },
      {
        path: "liquidacion",
        loadChildren: "./liquidacion/liquidacion.module#LiquidacionModule",
      },
      {
        path: "promociones",
        loadChildren: "./promociones/promociones.module#PromocionesModule",
      },
      {
        path: "componentes",
        loadChildren: "./componentes/componentes.module#ComponentesModule",
      
      },

      {
        path: "atencion",
        loadChildren: "./atencion/atencion.module#AtencionModule",
      },
      {
        path: "planeacion",
        loadChildren: "./planeacion/planeacion.module#PlaneacionModule",
      },
      {
        path: "operacion",
        loadChildren: "./operacion/operacion.module#OperacionModule",
      },
      {
        path: "ingresos",
        loadChildren: "./ingresos/ingresos.module#IngresosModule",
      },
      {
        path: "comercializacion",
        loadChildren:
          "./comercializacion/comercializacion.module#ComecializacionModule",
       
      },
      {
        path: "fiscalizacion",
        loadChildren:
          "./fiscalizacion/fiscalizacion.module#FiscalizacionModule",
      
      },
      {
        path: "administracion",
        loadChildren:
          "./administracion/administracion.module#AdministracionModule",
      },
      {
        path: "seguridad",
        loadChildren: "./seguridad/seguridad.module#SeguridadModule",
      },
    ],
  },
  {
    path: "",
    component: AuthLayoutComponent,
    children: [
      {
        path: "pages",
        loadChildren: "./pages/pages.module#PagesModule",
      
      },
    ],
  },
];
@NgModule({
  imports: [RouterModule.forRoot(AppRoutes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
